exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-MWM{text-align:center;font-family:Roboto,sans-serif}._3W6VI{border:0 none}._2a267{-ms-flex-pack:end;-webkit-box-pack:\"none\";justify-content:\"none\"}._2a267 button{font-family:Roboto\\, Medium,sans-serif;margin:0 auto}._sx73{margin:0 auto;font-family:Roboto\\, Bold,sans-serif;font-size:24px}._1TXAP{padding:0!important;margin:0!important}._23649 td,._23649 th{padding:7.2px;padding:.45rem;cursor:default}._23649{margin-bottom:0}._23649 th{border-top:0}tr{border-right:1px solid #efe5e5}._3Iajz ::-webkit-scrollbar{width:4px}._3Iajz ::-webkit-scrollbar-track{background:#fff}._3Iajz ::-webkit-scrollbar-thumb,._3Iajz ::-webkit-scrollbar-thumb:hover{background:#e4002b}", ""]);

// exports
exports.locals = {
	"modalContent": "p-MWM",
	"modalHeader": "_3W6VI",
	"modalFooter": "_2a267",
	"modalTitle": "_sx73",
	"noPadding": "_1TXAP",
	"table": "_23649",
	"modalScroll": "_3Iajz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalCuandoUtilizarEconsulta/ModalCuandoUtilizarEconsulta.css
// module id = 1296
// module chunks = 0 1